import React from 'react';

/**
 * Wrapper component that automatically applies 'introduction' class
 * Reduces repetitive className='introduction' throughout the codebase
 */
const IntroductionWrapper = ({ 
  children, 
  extraMargin = false,
  className = '',
  tag: Tag = 'div'
}) => {
  const classes = ['introduction'];
  
  if (extraMargin) {
    classes.push('extra-margin');
  }
  
  if (className) {
    classes.push(className);
  }

  return (
    <Tag className={classes.join(' ')}>
      {children}
    </Tag>
  );
};

export default IntroductionWrapper;